import { render } from "./Access.vue?vue&type=template&id=7d0de004&ts=true"
import script from "./Access.vue?vue&type=script&lang=ts"
export * from "./Access.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__